import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/"); return; }
    const sessionId = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        if (data.token) localStorage.setItem("token", data.token);
        setUser(data.user);
        window.history.replaceState({}, "", "/");
        if (data.user.role === "admin") navigate("/admin");
        else if (data.user.role === "driver") navigate("/driver");
        else navigate("/passenger");
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="brut-card p-8">
          <p className="font-mono-eyebrow">Authentification</p>
          <p className="font-display text-3xl mt-2">Chargement de la session...</p>
        </div>
    </div>
  );
}
